import { appInject, appInjectable } from "@core/di/utils";
import { BaseService } from "@core/services/base";
import { DI_TOKENS } from "@shared/constants/di";
import { IConfigService } from "@shared/interfaces/config-service.interface";
import { IHttpClientService } from "@shared/interfaces/http-client-service.interface";
import { IUploadService } from "@shared/interfaces/upload-service.interface";

@appInjectable()
export class UploadService extends BaseService implements IUploadService {
  private configService = appInject<IConfigService>(DI_TOKENS.configService);
  private httpClient = appInject<IHttpClientService>(
    DI_TOKENS.httpClientService,
  );
  private baseURL: string;

  constructor() {
    super();
    this.baseURL = this.configService.baseUrl;
  }

  uploadImage: IUploadService["uploadImage"] = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const { data } = await this.httpClient.post<any>("/uploads", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      baseURL: this.baseURL,
    });
    return data;
  };
}
